import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { withFormik } from "formik"
import { Formik, Form, Field, FieldArray, getIn } from "formik"
import Card, { TitleCard } from "../../core/Card"
import { push, goBack } from "react-router-redux"
import Line from "../../core/Line"
import {
  ForwardIcon,
  Icon,
  PlusIcon,
  MarkerIcon,
  BankCardIcon
} from "../../core/icons"
import { BrowserRouter as Router, Route, Link } from "react-router-dom"
import {
  Slider,
  Select,
  Button as AButton,
  Col,
  Row,
  Popover,
  Icon as AIcon,
  Switch,
  message,
  Popconfirm,
  Input,
  DatePicker,
  Alert
} from "antd"
// import { submit, reduxForm, Field, FieldArray } from "redux-form"
import moment from "moment"
import makeField from "../makeField"
import {
  mapOptionLabels,
  getAllowedFields,
  getRemainingDays,
  isAmountRangeValid,
  amountToExpenseOrRevenue,
  accountsFromInstitutionUsers,
  getCombinedPurpose,
  setPurposeAndIncomeSource,
  getPurposes,
  onObservedChange
} from "./"
import styled from "styled-components"
// import Accounts from "./Accounts"
const { Option } = Select
const { TextArea } = Input
const { RangePicker } = DatePicker
const AInput = makeField(Input)
const ATextArea = makeField(TextArea)
const ASelect = makeField(Select)

export const Button = styled(AButton).attrs({
  type: props => props.primary && "primary"
})`
  ${props =>
    props.link &&
    `
    background-color: transparent;
    border: none;
    box-shadow: none;
  `};
`

const TextAreaInput = ({
  name,
  type,
  id,
  label,
  error,
  value,
  onChange,
  className,
  ...props
}) => {
  return (
    <TextArea
      id={id}
      type={type}
      value={value}
      onChange={onChange}
      {...props}
    />
  )
}

const SelectInput = ({
  children,
  name,
  type,
  id,
  label,
  error,
  value,
  onChange,
  className,
  ...props
}) => {
  return (
    <Select
      id={id}
      type={type}
      value={value}
      onChange={v => {
        onChange(name, v)
      }}
      {...props}
    >
      {children}
    </Select>
  )
}

const FormikRangePicker = ({
  children,
  name,
  type,
  id,
  label,
  error,
  value,
  onChange,
  setFieldValue,
  index,
  className,
  ...props
}) => {
  return (
    <RangePicker
      ranges={rangePickerRanges}
      defaultValue={[null, null]}
      disabledDate={currentDate => currentDate.valueOf() < moment().valueOf()}
      format={"MM/DD/YYYY"}
      style={{ width: "100%" }}
      id={id}
      type={type}
      value={[
        value.start_date && moment(value.start_date),
        value.end_date && moment(value.end_date)
      ]}
      onChange={v => {
        setFieldValue(`rules.${index}.start_date`, v[0])
        setFieldValue(`rules.${index}.end_date`, v[1])
      }}
    />
  )
}

const rangePickerRanges = {
  "This Month": [moment().startOf("month"), moment().endOf("month")],
  "Next Month": [
    moment()
      .add(1, "month")
      .startOf("month"),
    moment()
      .add(1, "month")
      .endOf("month")
  ],
  "This Year": [moment().startOf("year"), moment().endOf("year")],
  "Next Year": [
    moment()
      .add(1, "year")
      .startOf("year"),
    moment()
      .add(1, "year")
      .endOf("year")
  ]
}

const getComparisonOperatorField = (rule, values, index, setFieldValue) => {
  switch (rule.observed_field) {
    case "date":
      // rule.type == "EqualityRule" &&
      return null
    case "category":
    case "merchant":
      return <span>contains: </span>

    case "institution_account_token_id":
    case "day_of_week":
      return <span>is: </span>

    default:
      return (
        <SelectInput
          name={`rules.${index}.comparison_operator`}
          id={`rules.${index}.comparison_operator`}
          value={values.rules[index].comparison_operator}
          onChange={setFieldValue}
        >
          <Option value={"="}>is equal to</Option>
          <Option value={"<"}>is less than</Option>
          <Option value={">"}>is greater than</Option>
        </SelectInput>
      )
  }
}

const Rule = ({
  tokenId,
  buttonTitle,
  title,
  values,
  handleSubmit,
  handleBlur,
  setFieldValue,
  setValues,
  handleChange,
  submitForm,
  touched,
  errors,
  observeField,
  institutionAccounts,
  actions,
  purposes,
  setFieldTouched,
  nextCondition,
  allowNextCondition,
  isFetching,
  ...rest
}) => (
  <div>
    <TitleCard sticky showBackButton>
      <h1>{title}</h1>
      <Button type="primary" loading={rest.isSubmitting} onClick={submitForm}>
        {buttonTitle}
      </Button>

      {actions.destroy && (
        <Popconfirm
          title="Are you sure?"
          placement="left"
          onConfirm={() => actions.destroy(tokenId)}
          onCancel={() => {
            console.log("canceled")
          }}
          okText="Yes"
          cancelText="No"
        >
          <Button type="danger" icon="delete" />
        </Popconfirm>
      )}
    </TitleCard>

    <Card showLoadingIcon={isFetching}>
      <form onSubmit={handleSubmit}>
        <h3>For transactions where...</h3>
        <FieldArray
          name="rules"
          // validateOnChange={false}
          render={arrayHelpers => {
            return (
              <div style={{ padding: 20 }}>
                {values.rules && values.rules.length > 0
                  ? values.rules.map((rule, index) => (
                      <div>
                        <Row
                          type="flex"
                          justify="space-between"
                          gutter={20}
                          align="middle"
                          key={index}
                        >
                          {errors.rules &&
                            errors.rules[index] &&
                            touched.rules &&
                            touched.rules[index] && (
                              <Col sm={24}>
                                <Row gutter={20} justify="end" type="flex">
                                  <Col>
                                    <Alert
                                      message={
                                        errors.rules[index].enforced_value
                                      }
                                      type="error"
                                    />
                                    <br />
                                  </Col>
                                  <Col sm={2} />
                                </Row>
                              </Col>
                            )}
                          <Col sm={8}>
                            <SelectInput
                              name={`rules.${index}.observed_field`}
                              value={values.rules[index].observed_field}
                              onChange={(field, value) => {
                                setValues({
                                  ...values,
                                  rules: [
                                    ...values.rules.map((v, i) => {
                                      if (i == index)
                                        return {
                                          // the rule to change
                                          ...v,
                                          ...onObservedChange(value)
                                        }
                                      return v
                                    })
                                  ]
                                })
                              }}
                            >
                              {mapOptionLabels(
                                getAllowedFields(
                                  values.rules.map((rule, i) => {
                                    if (i == index) return
                                    return rule.observed_field
                                  })
                                )
                              ).map(v => (
                                <Option value={v.value}>{v.name}</Option>
                              ))}
                            </SelectInput>
                          </Col>

                          <Col sm={6}>
                            {getComparisonOperatorField(
                              rule,
                              values,
                              index,
                              setFieldValue
                            )}
                          </Col>

                          <Col sm={8}>
                            {rule.observed_field ==
                            "institution_account_token_id" ? ( //or day_of_week
                              <SelectInput
                                name={`rules.${index}.enforced_value`}
                                id={`rules.${index}.enforced_value`}
                                value={values.rules[index].enforced_value}
                                onChange={setFieldValue}
                              >
                                {institutionAccounts.map((account, i) => (
                                  <Option
                                    key={i}
                                    value={account.institution_account_token_id}
                                  >
                                    <span style={{ color: "#dcd" }}>
                                      {account.institution_name} -
                                    </span>
                                    {account.displayName}
                                  </Option>
                                ))}
                              </SelectInput>
                            ) : rule.observed_field == "day_of_week" ? (
                              <SelectInput
                                name={`rules.${index}.enforced_value`}
                                id={`rules.${index}.enforced_value`}
                                value={values.rules[index].enforced_value}
                                onChange={setFieldValue}
                              >
                                {getRemainingDays(
                                  values.rules
                                    // filter for only days_of_week
                                    .filter(
                                      r => r.observed_field == "day_of_week"
                                    )
                                    // grab the values
                                    .map(rule => rule.enforced_value)
                                ).map(value => (
                                  <Option value={value}>{value}</Option>
                                ))}
                              </SelectInput>
                            ) : rule.observed_field == "date" ? (
                              <FormikRangePicker
                                setFieldValue={setFieldValue}
                                // name={`rules.${index}.enforced_value`}
                                index={index}
                                value={{
                                  start_date: values.rules[index].start_date,
                                  end_date: values.rules[index].end_date
                                }}
                              />
                            ) : (
                              <Input
                                style={{ height: 28 }}
                                placeholder="Enter here"
                                type={
                                  rule.observed_field == "expense" ||
                                  rule.observed_field == "revenue"
                                    ? "number"
                                    : "text"
                                }
                                name={`rules.${index}.enforced_value`}
                                id={`rules.${index}.enforced_value`}
                                value={values.rules[index].enforced_value}
                                onChange={handleChange}
                                onBlur={() =>
                                  setFieldTouched(
                                    `rules.${index}.enforced_value`,
                                    true
                                  )
                                }
                              />
                            )}
                          </Col>
                          <Col sm={2}>
                            <Button
                              link
                              type="danger"
                              icon="close"
                              onClick={() => arrayHelpers.remove(index)}
                            />
                          </Col>
                        </Row>
                        <Row justify="center" type="flex">
                          <span
                            style={{
                              padding: 20,
                              background: "white",
                              zIndex: 1
                            }}
                          >
                            and
                          </span>
                          <hr
                            style={{
                              "flex-basis": "100%",
                              margin: "-30px 0"
                            }}
                          />
                        </Row>
                      </div>
                    ))
                  : null}
                <div>
                  {allowNextCondition && (
                    <Button
                      link
                      type="default"
                      icon="plus"
                      onClick={() => arrayHelpers.push(nextCondition)}
                    >
                      Add condition
                    </Button>
                  )}
                </div>
              </div>
            )
          }}
        />

        <h3>Classify as...</h3>

        <div style={{ padding: 20 }}>
          {errors.rule_actions &&
            touched.rule_actions && (
              <Row gutter={20}>
                <Col sm={8} />

                <Col sm={14}>
                  <Alert
                    message={errors.rule_actions.enforced_value}
                    type="error"
                  />
                  <br />
                </Col>
                <Col sm={2} />
              </Row>
            )}
          <Row gutter={20}>
            <Col
              span={8}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <label>Purpose:</label>
            </Col>
            <Col sm={14}>
              <Select
                placeholder="Choose purpose"
                value={getCombinedPurpose(values.rule_actions)}
                onChange={value => {
                  setValues({
                    ...values,
                    rule_actions: [
                      // keep notes
                      ...values.rule_actions
                        // without old state purpose or income source
                        .filter(ra => ra.enforced_field == "notes"),
                      ...setPurposeAndIncomeSource(value)
                    ]
                  })
                }}
              >
                {purposes.map(purpose => (
                  <Option value={purpose}>{purpose}</Option>
                ))}
              </Select>
            </Col>
          </Row>

          {values.rule_actions.map(
            ({ id, enforced_field, enforced_value }, index) =>
              enforced_field == "notes" && (
                <Row id={id} gutter={20} style={{ paddingTop: 20 }}>
                  <Col
                    span={8}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <label>Notes:</label>
                  </Col>
                  <Col sm={14}>
                    <TextAreaInput
                      placeholder="Enter notes..."
                      name={`rule_actions.${index}.enforced_value`}
                      id={`rule_actions.${index}.enforced_value`}
                      value={enforced_value}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
              )
          )}
        </div>
      </form>
    </Card>
  </div>
)

const mapStateToProps = (state, ownProps) => {
  const nextAvailObservedField = getAllowedFields(
    ownProps.values.rules.map((rule, i) => {
      return rule.observed_field
    })
  )[0]
  return {
    nextCondition: onObservedChange(nextAvailObservedField),
    allowNextCondition: !!nextAvailObservedField,
    purposes: getPurposes(state),
    institutionAccounts: accountsFromInstitutionUsers(
      state.models.user.institution_users
    ),
    isFetching: state.models.user.isFetching
  }
}
export default connect(mapStateToProps)(Rule)



// WEBPACK FOOTER //
// ./src/account/favorite-transactions/Rule.js